import React from "react";
import styled from "styled-components";
import { generatePdf } from "../generatePdf";


const Button = styled.button`
  margin: 2px;
  padding: 3px 6px;
  font-size: 11px;
  cursor: pointer;
  border: 1px solid #007bff;
  border-radius: 6px;
  color: #007bff;
  background-color: transparent;
  white-space: nowrap;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #007bff;
    color: white;
  }

  &:active {
    transform: scale(0.98);
    background-color: #0056b3;
  }
`;

const PrintButton = ({ data }) => {
  const handlePrint = async () => {



    const blob = await generatePdf(data);
    const url = URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };
  };

  return <Button onClick={handlePrint}>Imprimir</Button>;
};

export default PrintButton;
